import React from 'react';

import { Languages } from '../components/languages';
import {
    ajax, plainDate, getNavigation, manageOrderStock,
    buildManageOrderStockDto, buildManageStockAddress, downloadCsv, loadAutocompleteCountries, autoCompleteForeignCitiesForCountry,
    ProfileLevels
} from '../components/globals';
import {
    numberValidation, nameValidation, emailValidation, emptyValidation,
    validate
} from '../components/validate';
import { InputColumn } from '../components/utilities';
import { UISummary, UIFilterPanel, UISummaryWidget, UISummaryWidgetBar, PageTitle, UIDataTable, UIDownload,  UIPopup, UIInput, UIButton, UICheckbox, UISelect } from '../components/guiElements';
import { FieldProps } from '../components/fieldProps';
import { v4 as uuidv4 } from 'uuid';

export default class Storaging extends React.Component {
    constructor(props) {
        super(props);

        this.listClick = this.listClick.bind(this);
        this.downloadExcel = this.downloadExcel.bind(this);
        this.modalChange = this.modalChange.bind(this);
        this.addressModalClick = this.addressModalClick.bind(this);
        this.addressModalChange = this.addressModalChange.bind(this);
        this.manageOrderStockExec = this.manageOrderStockExec.bind(this);
        this.getData = this.getData.bind(this);
        this.filtersChange = this.filtersChange.bind(this);

        this.onAutocompleteCountryChange = this.onAutocompleteCountryChange.bind(this);
        this.onAutocompleteCountrySelected = this.onAutocompleteCountrySelected.bind(this);

        this.onAutocompleteCityChange = this.onAutocompleteCityChange.bind(this);
        this.onAutocompleteCitySelected = this.onAutocompleteCitySelected.bind(this);

        this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.le = Languages.Storaging[Languages.selectedLanguage];
        this.leMain = Languages.Main[Languages.selectedLanguage];

        this.configs = {
            filters: {
                orderNum: { type: "text", width: "20%" }
            },
            modalData: [
                { name: 'recipient', title: this.le.update.inputs[0], class: null },
                { name: 'courier', title: this.le.update.inputs[1], class: null },
                { name: 'orderNo', title: this.le.update.inputs[2], class: null },
                { name: 'reason', title: this.le.update.inputs[3], class: null }
            ]
        };

        this.header = [
            {
                generic: { manage: 0, name: 'date', width: 15, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold', value: this.le.list.captions[0] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            }, {
                generic: { manage: 0, name: 'orderNo', width: 22, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold', value: this.le.list.captions[1] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            }, {
                generic: { manage: 0, name: 'courier', width: 12, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold', value: this.le.list.captions[2] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            }, {
                generic: { manage: 0, name: 'reason', width: 17, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold left', value: this.le.list.captions[3] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            }, {
                generic: { manage: 3, default: null, name: 'actions', width: 11, change: null, click: this.listClick },
                caption: { type: 'label', colClass: null, itemClass: 'bold center', value: this.le.list.captions[4] },
                element: { type: 'button', colClass: 'center', itemClass: 'modify', options: this.le.list.listButton }
        }];

        if (this.uc && this.uc.userRole === ProfileLevels[2]) {
            this.header.pop(); //remove actions
        }

        this.listKey = 1;

        let filters = {};

        Object.keys(this.configs.filters).forEach(key => {
            filters[key] = this.configs.filters[key].type == "checkbox" ? false : "";
        });

        this.appliedFilters = filters;

        //#region Automatic Support Data
        let mngIdx = 0, entIdx = 0;
        this.dataIndexes = this.header.map((el) => ({ manage: el.generic.manage, name: el.generic.name, idx: (el.generic.manage > 0 ? mngIdx++ : entIdx++) }));
        this.defaultManager = this.header.filter((el) => (el.generic.manage > 0)).map((el) => (el.generic.default));
        //#endregion Automatic Support Data

        let navigation = getNavigation(this.getData, this.leMain.navigation);

        this.state = {
            entries: [],
            filters: filters,
            orders:[],
            managers: Array(1).fill().map(() => (this.defaultManager.slice())),
            totals: [],
            modalType: 0,
            modalReference: null,
            modalData: ['', '', '', ''],
            addressModalColumn: {
                id: 'C1',
                rowsize: 30,
                itemunit: 10,
                items: [
                    { id: 'name',mandatory: true, size: 15, text: this.le.addressUpdate.inputs[0], type: 'text', value: '', class: null, validate: emptyValidation },
                    { id: 'surname',mandatory: true, size: 15, text: this.le.addressUpdate.inputs[1], type: 'text', value: '', class: null },
                    { id: 'address',mandatory: true, size: 20, text: this.le.addressUpdate.inputs[2], type: 'text', value: '', class: null, validate: emptyValidation},
                    { id: 'houseNo',mandatory: false, size: 10, text: this.le.addressUpdate.inputs[3], type: 'text', value: '', class: null },
                    {
                        id: 'country', 
                        mandatory: true,
                        size: 30,
                        text: this.le.addressUpdate.inputs[4], 
                        maxLength: FieldProps.getFieldProp('country', 'maxLength'),
                        type: 'autocomplete-country', 
                        options: [],
                        validate: emptyValidation
                    },
                    {
                        id: 'city',
                        mandatory: true,
                        size: 30, 
                        text: this.le.addressUpdate.inputs[5], 
                        type: 'autocomplete',
                        value: '',
                        class: null, 
                        validate: emptyValidation,
                        options: [],
                        maxLength: FieldProps.getFieldProp('city', 'maxLength')
                    },
                    { id: 'province',mandatory: true, size: 20, text: this.le.addressUpdate.inputs[6], type: 'text', value: '', class: null, validate: emptyValidation},
                    { id: 'zip', mandatory: true, size: 10, text: this.le.addressUpdate.inputs[7], type: 'text', value: '', class: null, validate: emptyValidation},
                    { id: 'note', mandatory: false, size: 30, text: this.le.addressUpdate.inputs[11], type: 'text', value: '', class: null },

                    //{ id: 'orderNo', size: 30, text: this.le.update.inputs[7], type: 'text', value: '', class: null },
                    //{ id: 'courier', size: 15, text: this.le.update.inputs[8], type: 'text', value: '', class: null },
                    //{ id: 'date', size: 15, text: this.le.update.inputs[9], type: 'text', value: '', class: null }

                ]
            },
            countries: [],
            countryId: "",
            suggestedCountry: [],
            suggestedCity:[],
            modalPar: null,
            navigation: navigation
        };

        // indexes remapping entries with the input boxes of modal box
        this.modalDataMap = [[0, 6], [1, 2], [2, 1], [3, 3]];
        this.addressModalDataMap = [[0, 7], [1, 8], [2, 9], [3, 10], [4, 11], [5, 12], [6, 13], [7, 14]];
    }


    componentDidMount() {
        this.getData(this.state.navigation);
        loadAutocompleteCountries(this.uc.jwtToken, (countries) => {
            this.setState({
                countries: countries
            });
        },
        ko => { },
        this);
    }

    togglePropertyField({ items, fieldName, booleanValue, propertyName}) {
        const foundItem = items.find(item => item.id === fieldName);
        const foundItemIndex = items.findIndex(item => item.id === fieldName);
        foundItem[propertyName] = booleanValue;
        items[foundItemIndex] = foundItem;
    }

    resetCityProvinceZipField(items,newData, who, value, booleanValue) {
        items.forEach((item => {
            if(item.id === 'country') {
                item.value = value;
            }else if (item.id === 'city') {
                item.value = '';
            }else if (item.id === 'province') {
                item.value = '';
            }else if (item.id === 'zip') {
                item.value = '';
            }
        }));
    }

    onAutocompleteCountryChange(who, value) { 
        let newData = {...this.state.addressModalColumn};
        newData.items[who[1]].value = value;

        if (value.length >= 3) {
            const foundCountry = this.findCountry(value);
            const suggestedCountry = foundCountry
            this.setState({
                suggestedCountry : suggestedCountry,
                countryId: foundCountry.idcountry,
                addressModalColumn: newData
            });
        } else {
            let newData = {...this.state.addressModalColumn};
            const items = newData.items;
            this.setState({ addressModalColumn: newData, suggestedCountry: [] });
        }
    }

    onAutocompleteCountrySelected(who, value, countryId) {
        let newData = {...this.state.addressModalColumn};
        const items = newData.items;
        this.resetCityProvinceZipField(items,newData, who, value, false);
        this.setState({ addressModalColumn: newData, countryId: countryId, suggestedCity: [] });
    }

    onAutocompleteCityChange(who,  value ) {
        let newData = {...this.state.addressModalColumn};
        newData.items[who[1]].value = value;
        let countryId = this.state.countryId;

        if(countryId.length === 0) {
            const countryName = newData.items[4].value
            const country = this.findCountry(countryName);
            countryId = country[0]?.countryId;
        }


        let suggested = [];
        if (value.length >= 3 && countryId) {
            (autoCompleteForeignCitiesForCountry(value,
                countryId,
                response => {
                    response.data.forEach((el) => {
                        suggested.push({
                            id: el.Id,
                            label: el.Label,
                            labelShort:el.LabelShort, 
                            cityName: el.CityName,
                            provinceCode: el.ProvinceCode,
                            zipCode: el.Value
                        }); 
                    });
                    this.setState(prevState => {
                        let prevSuggestedCity = [...prevState.suggestedCity];
                        prevSuggestedCity = suggested;
                        return  { addressModalColumn: newData, suggestedCity: prevSuggestedCity }
                    })
                }));
        } 
        
        else {
            this.setState({ addressModalColumn: newData, suggestedCity: suggested });
        }
    }
    
    onAutocompleteCitySelected(who, item) {
        let newData = {...this.state.addressModalColumn};
        const items = newData.items;
        items.forEach((fieldObject => {
            if (fieldObject.id === 'city') {
                fieldObject.value = this.getCityName(item);
            }else if (fieldObject.id === 'province') {
                fieldObject.value = this.getProvinceName(item);
            }else if (fieldObject.id === 'zip') {
                fieldObject.value = this.getZipCode(item);
            }
        }));

        this.checkForMandatoryFields(items, item);
        this.setState({ addressModalColumn: {...newData, items: items} });
    }

    checkForMandatoryFields(items, item) {
        if(!this.getProvinceName(item)) {
            this.togglePropertyField({
              items,
              fieldName: 'province',
              booleanValue: false,
              propertyName: "mandatory" 
            });
          } else {
              this.togglePropertyField({
                  items,
                  fieldName: 'province',
                  booleanValue: true,
                  propertyName: "mandatory" 
              });
          }
  
          if(!this.getZipCode(item)) {
              this.togglePropertyField({
                  items,
                  fieldName: 'zip',
                  booleanValue: false,
                  propertyName: "mandatory" 
              });
            } else {
              this.togglePropertyField({
                  items,
                  fieldName: 'zip',
                  booleanValue: true,
                  propertyName: "mandatory" 
              });
          }
    }

    findCountry(countryName) {
        const foundCountry = this.state.countries
        .filter((el) => el.name.toLowerCase().includes(countryName.toLowerCase()))
        .map(el => {
            return {label: el.name, countryId: el.idcountry}
        });

        return foundCountry;
    }

    getCityName(cityObject) {
        const cityName = cityObject?.cityName;
        const labelShort = cityObject?.labelShort;
        const zipCode = cityObject?.zipCode;

        if(cityName) {
            return cityName;
        }


        if(zipCode && zipCode.length > 0) {
            return labelShort.split(zipCode)[0].trim()
        }

        if(!cityName) {
            return labelShort.trim();
        }

        if(zipCode && zipCode.length === 0) {
            return ''
        }
    }

    getProvinceName(cityObject) {
        const cityName = cityObject?.cityName;
        const provinceCode = cityObject?.provinceCode;
        if(cityName) {
            return provinceCode;
        }

        if(!cityName && provinceCode) {
            return provinceCode;
        }

        if(!cityName && !provinceCode) {
            return '';
        }
    }

    getZipCode(cityObject) {
        const cityName = cityObject?.cityName;
        // const labelShort = cityObject?.labelShort;
        const provinceCode = cityObject?.provinceCode;
        const zipCode = cityObject?.zipCode;

        if(cityName) {
            return zipCode;
        }

        if(!cityName && zipCode) {
            return zipCode;
        }

        if(!cityName && !provinceCode) {
            return '';
        }
    }

    validate(items) {
        let validation = [];

        for (let i = 0; i < items.length; i++) {
            let el = items[i];
            if (el.hasOwnProperty("validate") && el.mandatory) {
                validation.push({
                    fieldObject: el,
                    fieldName: el.id,
                    fieldValue: el.value,
                    fieldError: 'error',
                    validate: el.validate
                });
            }
        }

        return validate(validation);
    }

    findOrder(orderNum) {
        let order = this.state.orders.find(a => a.orderNum == orderNum);
        if (order == undefined) {
            return null;
        }
            
        return order;
    }
    //#region Data functions

    filtersChange(ev) {
        let name = ev.target.name;
        let value = (ev.target.type == 'checkbox' || ev.target.type == 'checkbox') ? ev.target.checked : ev.target.value;
        let newFilters = Object.assign({}, this.state.filters);
        newFilters[name] = value;
        this.setState({ filters: newFilters });

        if (JSON.stringify(newFilters) !== JSON.stringify(this.appliedFilters)) {
            this.appliedFilters = newFilters;
            let navigation = this.state.navigation;
            navigation.pageNo.value = 0;
            this.getData(navigation);
        }
    }

    buildEntries(orders) {
        let entries = [];
        for (let i = 0; i < orders.length; i++) {
            let order = orders[i];
            let entry = [];
            entry.push(plainDate(order.orderDate));
            entry.push(order.orderNum);
            entry.push(order.carrierSign);
            entry.push(order.reasonDesc);
            entry.push(order.reasonType);
            entry.push(order.stockNum);
            entry.push(order.customer);
            for (let i2 = 0; i2 < 8; i2++) {
                entry.push("");
            }
            if (order.orderRecipient != null) {
                let i2 = entry.length;
                entry[i2++] = order.orderRecipient.name;
                entry[i2++] = order.orderRecipient.surname;
                entry[i2++] = order.orderRecipient.address;
                entry[i2++] = order.orderRecipient.houseNo;
                entry[i2++] = order.orderRecipient.country;
                entry[i2++] = order.orderRecipient.city;
                entry[i2++] = order.orderRecipient.province;
                entry[i2++] = order.orderRecipient.zip;
                entry[i2++] = order.orderRecipient.note;
            }
           
            entries.push(entry);
        }


        return entries;
    }

    getData(navigation) {
        try {
            const filters = encodeURIComponent(JSON.stringify(this.appliedFilters));
            const url = '/api/stock/stock/' + navigation.pageNo.value + '/' + navigation.pageSize.value + "/" + filters;
            this.props.loaderShow(0);
            ajax(this, { method: 'get', url: url, headers: { Authorization: 'Bearer ' + this.uc.jwtToken } },
                response => {
                    //let entries = this.props.entries;
                    this.props.loaderHide();
                    let entries = this.buildEntries(response.data.result.stocks);
                    /*let entries = response.data.result.stocks.map(el => ([
                        plainDate(el.orderDate), el.orderNum, el.carrierSign, el.reasonDesc, el.reasonType, el.stockNum, el.customer
                    ]));*/
                    navigation.totalItems.value = response.data.result.totItems;
                    let totals = [{ name: 'storage', val: response.data.result.totItems }];

                    this.setState({
                        entries: entries,
                        orders: response.data.result.stocks,
                        managers: Array(entries.length + 1).fill().map(() => (this.defaultManager.slice())),
                        navigation: navigation,
                        totals: totals
                    });
                },
                error => {
                    this.props.loaderHide();
                    const msg = Languages.Main[Languages.selectedLanguage].messages.msgError;

                    /*let obj = {
                        title: msg.title,
                        width: "35%",
                        icon: "error",
                        messages: msg.messages,
                        buttons: [{ name: "ok", type: "confirm", width: "40%", text: "ok", class: "right", click: null }]
                    };
                    this.props.popUp(obj);*/

                    this.props.popupErrorMessage(msg.messages);
                }
            );
        }
        catch (e){

        }
    }

    manageOrderStockExec(orderNum,action,newAddress,ok) {

        let me = this;
        let data = buildManageOrderStockDto();

        data.orderNum = orderNum;
        if (action == 'newaddress') {
            data.address = newAddress;
        }
        this.props.loaderShow();

        manageOrderStock(this.uc.jwtToken, action, data,
            success => {
                this.props.loaderHide();

                let popupExit = function () {

                    me.getData(me.state.navigation);
                    ok.call(me);
                };

                this.props.loaderHide();
                const msg = this.le.messages.success;
                let obj = {
                    title: msg.captions[0],
                    width: "35%",
                    icon: "info",
                    messages: msg.messages,
                    buttons: [{
                        name: "ok", type: "confirm", width: "40%", text: "ok", class: "right",
                        click: popupExit
                    }]
                };
                this.props.popUp(obj);


            },
            error => {
                this.props.loaderHide();
                const msg = this.le.messages.error;
                /*let obj = {
                    title: msg.captions[0],
                    width: "35%",
                    icon: "info",
                    messages: error != undefined && error != null && error.hasOwnProperty("errorMessage")
                        ? [error.errorMessage] : msg.messages,
                    buttons: [{
                        name: "ok", type: "confirm", width: "40%", text: "ok", class: "right",
                        click: null
                    }]
                };
                this.props.popUp(obj);*/
                let messages = undefined && error != null && error.hasOwnProperty("errorMessage")
                    ? [error.errorMessage] : msg.messages;
                this.props.popupErrorMessage(messages);
            });
    }

    //#endregion Data functions

    //#region Events

  

    listClick(ev) {
        let source = ev.target.value;
        let mdlDt = JSON.parse(JSON.stringify(this.state.modalData));
        const idx = this.state.entries.findIndex((el) => (el[this.listKey] === source));
        const ds = this.state.entries[idx];
        this.modalDataMap.forEach((el) => {
            mdlDt[el[0]] = ds[el[1]]; 
        });

        this.setState({ modalType: 1, modalReference: source, modalPar: ds[5], modalData: mdlDt });
    }

    downloadExcel(ev, data) {
        try {

            downloadCsv(this.uc.jwtToken, 'stock', this.state.navigation.pageNo.value, this.state.navigation.pageSize.value,
                {},
                error => {
                    const msg = this.leMain.messages.msgError;
                    this.props.popupErrorMessage(msg.messages);
                }, this);
        }
        catch (e) {
            const msg = this.leMain.messages.msgError;
            this.props.popupErrorMessage(msg.messages);
        }
    }

    addressModalClick(ev, action) {
        try {
            if (action) {

                let addressModalColumn = this.state.addressModalColumn;
                if (!this.validate(addressModalColumn.items)) {
                    this.setState({ addressModalColumn: addressModalColumn });
                    return;
                }
                let newAddress = buildManageStockAddress();
                newAddress.newAddress = this.state.addressModalColumn.items[2].value;
                if (this.state.addressModalColumn.items[3].value != null && this.state.addressModalColumn.items[3].value != "") {
                    newAddress.newAddress = newAddress.newAddress + " " + this.state.addressModalColumn.items[3].value;
                }
                    
                
                newAddress.firstName = this.state.addressModalColumn.items[0].value;
                newAddress.lastName = this.state.addressModalColumn.items[1].value;
                newAddress.newCountry = this.state.addressModalColumn.items[4].value;
                newAddress.newLocation = this.state.addressModalColumn.items[5].value;
                newAddress.newProvince = this.state.addressModalColumn.items[6].value;
                newAddress.newZipcode = this.state.addressModalColumn.items[7].value;
                newAddress.note = this.state.addressModalColumn.items[8].value;
                this.manageOrderStockExec(this.state.modalReference, 'newaddress', newAddress,
                    ok => {

                        this.setState({ modalType: 0, modalReference: null });
                    });
            }
            else
                this.setState({ modalType: 0, modalReference: null });
        }
        catch (e) {
            const msg = Languages.Main[Languages.selectedLanguage].messages.msgError;
            this.props.popupErrorMessage(msg.messages);
        }
    }

    addressModalChange(ev, who, value) {
        let mdlCol = this.state.addressModalColumn;
        mdlCol.items[who[1]].value = value;
        this.setState({ addressModalColumn: mdlCol });
    }

    modalClick(ev, action) {
        try {
            switch (action) {
                case 'back':
                    this.manageOrderStockExec(this.state.modalReference, 'cancel', null,
                        ok => {
                            this.setState({ modalType: 0, modalReference: null });
                        });
                    break;
                case 'retry':
                    this.manageOrderStockExec(this.state.modalReference, 'retry', null,
                        ok => {
                            this.setState({ modalType: 0, modalReference: null });
                        });
                    break;
                case 'change-addr':
                    let mdlCol = this.state.addressModalColumn;
                    let order = this.findOrder(this.state.modalReference);
                    const items = mdlCol.items;
                    if (order != null && order.orderRecipient != null) {
                        for (let i = 0; i < mdlCol.items.length; i++) {
                            let el = mdlCol.items[i];
                            el.error = false;
                            if (el.id in order.orderRecipient) {
                                el.value = order.orderRecipient[el.id];
                            }
                        }
                    }
                    const orderRecipient = order.orderRecipient;
                    let item = {
                        labelShort: orderRecipient.city, 
                        cityName: orderRecipient.city,
                        provinceCode: orderRecipient.province,
                        zipCode: orderRecipient.zip
                    }
                    this.checkForMandatoryFields(items, item);
                    this.setState({ modalType: 2, addressModalColumn: mdlCol, items: items });
                    break;

                default:
                    this.setState({ modalType: 0, modalReference: null });
                    break;
            }
        }
        catch (e) {
            const msg = Languages.Main[Languages.selectedLanguage].messages.msgError;
            this.props.popupErrorMessage(msg.messages);
        }
        
    }

    modalChange(ev, who, value) {
        let mdlCol = this.state.modalColumn;
        mdlCol.items[who[1]].value = value;
        this.setState({ modalColumn: mdlCol });
    }
   

    //#endregion Events

    render() {
        let modal = (<div />);
        
        if (this.state.modalType == 1) {
            const le = this.le.update, title = le.title.replace('%goodsNo%', this.state.modalPar), btnClass = "reduced no-spacing";
            let items = <div  className="popup-info-block flex-panel "> {
                    this.configs.modalData.map((el, idx) => (
                        [<div key={uuidv4()} className="popup-info-block-title">{el.title}</div>,
                            <div key={uuidv4()} className="popup-info-block-value">{this.state.modalData[idx]}</div>]))
                }
                </div>;
            let buttons = [
                <UIButton key={uuidv4()} text={le.buttons[0]} onClick={(ev) => this.modalClick(ev, 'back')} />,
                <UIButton key={uuidv4()} className="confirm" text={le.buttons[1]} onClick={(ev) => this.modalClick(ev, 'retry')} />,
                <UIButton key={uuidv4()} className="confirm" text={le.buttons[2]} onClick={(ev) => this.modalClick(ev, 'change-addr')} />];

            modal = <UIPopup 
                        className=""
                        onCancel={(ev) => (this.modalClick(ev, 'close'))}
                        title={title} buttons={buttons}>
                {items}
            </UIPopup>
        } else if (this.state.modalType == 2) {  
            let suggestedOptions = {...this.state.addressModalColumn};
            suggestedOptions.items[4].options = this.state.suggestedCountry;   
            suggestedOptions.items[5].options = this.state.suggestedCity;
            const le = this.le.addressUpdate;
            let addritems = [];
            addritems = <div className="popup-address-block flex-panel ">
                <InputColumn 
                    column={this.state.modalReference}
                    data={this.state.addressModalColumn}
                    onChange={this.addressModalChange}
                    onAutocompleteCountryChange={this.onAutocompleteCountryChange}
                    onAutocompleteCountrySelected={this.onAutocompleteCountrySelected}

                    onAutocompleteChange={this.onAutocompleteCityChange}
                    onAutocompleteSelected={this.onAutocompleteCitySelected} />
            </div>;

            modal = <UIPopup className="" 
                        onCancel={(ev) => (this.addressModalClick(ev, false))}
                        title={le.title}
                        buttons={[<UIButton key={uuidv4()} text={le.button} className="confirm"
                        onClick={(ev) => (this.addressModalClick(ev, true))}/>
                    ]}>
                {addritems}
            </UIPopup>
        }

        let filters = {};

        Object.entries(this.configs.filters).forEach(([key, val]) => {
            filters[key] = Object.assign({ value: this.state.filters[key] }, val);
        }, this);

        let pageFilters = Object.entries(filters).map(([key, val]) => {
            switch (val.type) {
                case "select":
                    return <UISelect key={key} name={key} options={val.options} value={val.value} onChange={this.filtersChange} />;
                case "checkbox":
                    return <UICheckbox key={key} name={key} onChange={this.filtersChange} value={val.value} label={this.le.filters.items[key]} />;
                default:
                    return <UIInput key={key} type={val.type} name={key} maxDate={new Date()} onChange={this.filtersChange} value={val.value} hint={this.le.filters.items[key]} />;
            }
        }, this);
        pageFilters.push(<UIDownload key={uuidv4()} title={this.le.list.button} onClick={this.downloadExcel} />);

        let amount = this.state.totals.length > 0 ? String(this.state.totals[0].val).replace(/(\d)(?=(\d{3})+\b)/g, '$1.') : 0;
        return <div className="page-storaging">
                <PageTitle icon="../images/mainMenu/Giacenze.png" title={Languages.getSection('Main').menuLabels.stockHandling} />
                <div className="page-content">
                    <UISummary>
                        <UISummaryWidgetBar>
                            <UISummaryWidget className="" title="" mainScore={amount} subScore="n/d" />
                        </UISummaryWidgetBar>
                    </UISummary>

                    <UIFilterPanel>
                        {pageFilters}
                    </UIFilterPanel>

                    {/*<div className="page-summary">
                        <div className="page-summary-title">{this.le.card.title} {amount}</div>
                        <div className="page-summary-entries">
                            <div key="{el.name}" className="page-summary-entry">
                                <UIDownload title={this.le.list.button} onClick={this.downloadExcel}/>
                            </div>
                        </div>
                    </div>*/}
                    <UIDataTable header={this.header} entries={this.state.entries} listKey={this.listKey} managers={this.state.managers} navigation={this.state.navigation} />

                    {/*<div className="container-fluid">
                        <div className="row">
                            <div className="col-4">
                                <UGrandTotals title={this.le.card.title} totals={totals} />
                            </div>
                            <div className="col-8">
                                <div className="container-fluid ucard">
                                    <div className="row">
                                        <UTitleFlat text={this.le.list.title} />
                                        <UListButtonFlat data={btnData} colClass="right up variation" onClick={this.downloadExcel} />
                                    </div>
                                    <UItemsList listId={this.constructor.name + "ItemsList"} listKey={this.listKey} header={this.header}
                                        entries={this.state.entries} managers={this.state.managers} navigation={this.state.navigation} />
                                </div>
                            </div>
                        </div>
                    </div>*/}

                </div>
                {modal}
            </div>;
    }
}


